import React from "react";
import BarreNavigation from "./composants/BarreNavigation";
import Apropos from "./pages/Apropos";
import Services from "./pages/Services";
import Projets from "./pages/Projets";
import Contact from "./pages/Contact";
import PiedPage from "./composants/PiedPage";

function App() {
  return (
    <div className="bg-gray-50 min-h-screen font-sans">
      {/* Barre de navigation */}
      <BarreNavigation />

      {/* Section d'accueil */}
<section
  id="accueil"
  className="flex items-center justify-center h-screen text-center bg-gray-50 text-black px-6"
>
  <div className="max-w-3xl">
    <h1 className="text-5xl font-bold mb-4 leading-tight text-black">
      L’innovation au service de votre infrastructure digitale
    </h1>
    <p className="text-lg mb-8 text-gray-800">
      Des solutions informatiques fiables, sécurisées et évolutives
      conçues pour propulser votre entreprise vers l’avenir.
    </p>
    <a
      href="#contact"
      className="bg-black text-white px-6 py-3 rounded-full font-semibold"
    >
      Obtenir une consultation
    </a>
  </div>
</section>




      {/* Section À propos */}
      <Apropos />

      {/* Section Services */}
      <Services />
      <Projets />
      <Contact />
      <PiedPage />
    </div>
  );
}

export default App;
